import { BrowserRouter, Route, Routes } from "react-router";

import { useSegment } from "sj-ui-toolkit/src/hooks";
import { UserAppRoutes } from "sj-ui-toolkit/src/constants/routes";

import { ProfileLayout } from "./components/ProfileLayout";
import { AchievementsTab } from "./components/tabs/Achievements/AchievementsTab";
import { ProfileDetailsTab } from "./components/tabs/Profile/ProfileDetailsTab";
import { CertificatesTab } from "./components/tabs/Certificates/CertificatesTab";
import { HistoryTab } from "./components/tabs/History/HistoryTab";
import { SettingsTab } from "./components/tabs/Settings/SettingsTab";
import { UserNotesTab } from "./components/tabs/Notes/UserNotesTab";

function App() {
  useSegment();

  return (
    <BrowserRouter>
      <Routes>
        <Route path={UserAppRoutes.route} element={<ProfileLayout />}>
          <Route index element={<ProfileDetailsTab />} />
          <Route path={UserAppRoutes.routes.achievements.route} element={<AchievementsTab />} />
          <Route path={UserAppRoutes.routes.certificates.route} element={<CertificatesTab />} />
          <Route path={UserAppRoutes.routes.notes.route} element={<UserNotesTab />} />
          <Route path={UserAppRoutes.routes.history.route} element={<HistoryTab />} />
          <Route path={UserAppRoutes.routes.settings.route} element={<SettingsTab />} />
          {/* If nothing else matches, just show the profile details tab */}
          <Route path="*" element={<ProfileDetailsTab />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
